import type { User } from "types/UserZendesk";
import { useEffect, useState } from "react";

export function useUserForm(selectedUser: User | null) {
    const [formData, setFormData] = useState({
        cpf_3: selectedUser?.user_fields?.cpf_3?.toString() ?? " ",
        name: selectedUser?.name ?? null,
        phone: selectedUser?.phone ?? null,
        email: selectedUser?.email ?? null,
        cnpj_regex: selectedUser?.user_fields?.cnpj_regex?.toString() ?? " "
    });

    useEffect(() => {
        if (selectedUser) {
          
            setFormData({
                cpf_3: selectedUser.user_fields?.cpf_3?.toString() ?? " ",
                name: selectedUser.name ?? null,
                phone: selectedUser.phone ?? null,
                email: selectedUser.email ?? null,
                cnpj_regex: selectedUser.user_fields?.cnpj_regex?.toString() ?? " "
            });
        }
    }, [selectedUser]);

    return { formData, setFormData };
}